import "$styles/index.css"

const THEME_KEY = "nr-theme"

function preferredTheme() {
  const stored = localStorage.getItem(THEME_KEY)
  if (stored === "light" || stored === "dark") return stored
  return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light"
}

function applyTheme(theme) {
  document.documentElement.classList.toggle("dark", theme === "dark")
  localStorage.setItem(THEME_KEY, theme)
  document.querySelectorAll("[data-theme-icon]").forEach((el) => {
    el.hidden = el.dataset.themeIcon !== theme
  })
}

document.addEventListener("DOMContentLoaded", () => {
  applyTheme(preferredTheme())

  document.querySelectorAll("[data-theme-toggle]").forEach((btn) => {
    btn.addEventListener("click", () => {
      const next = document.documentElement.classList.contains("dark") ? "light" : "dark"
      applyTheme(next)
    })
  })

  const sections = Array.from(document.querySelectorAll("main section[id]"))
  const links = Array.from(document.querySelectorAll(".nav-link[href^='#']"))
  if (sections.length === 0 || links.length === 0) return

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return
        const id = entry.target.id
        links.forEach((link) => {
          link.classList.toggle("is-active", link.getAttribute("href") === `#${id}`)
        })
      })
    },
    { rootMargin: "-35% 0px -55% 0px", threshold: 0 }
  )

  sections.forEach((section) => observer.observe(section))
})
